import { Injectable } from '@angular/core';
import { HisBackendService } from 'hisng';
import { Observable, map } from 'rxjs';
import { Bahncard, BahncardBackend, BahncardFactory } from '../../businesstripapplication/model/bahncard';
import { Account } from '../../businesstripapplication/model/bankdetails';

@Injectable()
export class ErpTravelManagementCommonService {

    constructor( private readonly backendService: HisBackendService ) { }

    getBahncardsByPgdJoinId( pgdJoinId: number ): Observable<Bahncard> {
        return this.backendService.getData( `api/v1/rm/erp/travelmanagement/bahncard/${pgdJoinId}` )
            .pipe( map( ( response: BahncardBackend ) => {
                return BahncardFactory.createFromBackendModel( response );
            } ) );
    }

    saveBahncardChanges( bahncard: Bahncard ): Observable<Bahncard> {
        return this.backendService.putData( 'api/v1/rm/erp/travelmanagement/bahncard', bahncard )
            .pipe( map( ( response: BahncardBackend ) => {
                return BahncardFactory.createFromBackendModel( response );
            } ) );
    }

    getAccounts(): Observable<Account[]> {
        return this.backendService.getData( 'api/v1/rm/erp/travelmanagement/values/erpaccount' );
    }
}
